import React from 'react';
const yesItems = ['Tuviste cándida más de 2 veces en el último año', 'Los óvulos te funcionan solo unos días', 'Sospechás que "algo más" está pasando', 'Querés entender la causa y no solo apagar el fuego', 'Estás cansada de gastar una fortuna en farmacia', 'Querés recuperar tu vida íntima sin miedo'];
const noItems = ['Tenés fiebre alta o lesiones graves sin diagnóstico', 'Sospechás una ITS no tratada', 'Estás embarazada sin supervisión médica', 'Buscás reemplazar un tratamiento médico urgente', 'Querés resultados sin ningún cambio de hábito'];
export function ForWhomSection() {
  return <section className="w-full bg-[#F8F5FC] px-6 py-16" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <h2 className="text-[28px] font-bold text-brand-text text-center mb-2 leading-tight" data-id="element-76">
          ESTO ES IMPORTANTE ANTES DE COMPRAR
        </h2>
        <p className="text-brand-muted text-center text-[16px] mb-12" data-id="element-77">
          ¿Es para vos?
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-78">
          <div className="bg-green-50 rounded-[16px] p-6 border border-green-100 shadow-[0_4px_24px_rgba(0,0,0,0.04)]" data-id="element-79">
            <h3 className="text-green-800 font-bold text-[16px] mb-5" data-id="element-80">
              ✅ ESTO ES PARA VOS SI:
            </h3>
            <ul className="flex flex-col gap-4" data-id="element-81">
              {yesItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-82">
                  <span className="text-green-600 mt-0.5" data-id="element-83">✅</span>
                  <span className="text-brand-text text-[15px] leading-snug" data-id="element-84">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="bg-red-50 rounded-[16px] p-6 border border-red-100 shadow-[0_4px_24px_rgba(0,0,0,0.04)]" data-id="element-85">
            <h3 className="text-red-800 font-bold text-[16px] mb-5" data-id="element-86">
              ❌ ESTO NO ES PARA VOS SI:
            </h3>
            <ul className="flex flex-col gap-4" data-id="element-87">
              {noItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-88">
                  <span className="text-red-600 mt-0.5" data-id="element-89">❌</span>
                  <span className="text-brand-text text-[15px] leading-snug" data-id="element-90">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="text-[13px] text-brand-muted leading-relaxed text-center italic max-w-2xl mx-auto" data-id="element-91">
          ⚕️ El Método pH-ZERO es un protocolo de biología funcional
          complementario. No reemplaza el diagnóstico médico profesional. Para
          síntomas graves, consultá a un profesional de salud.
        </p>
      </div>
    </section>;
}